import { render } from "./NavPrompt.vue?vue&type=template&id=1dd0f8b4"
import script from "./NavPrompt.vue?vue&type=script&lang=js"
export * from "./NavPrompt.vue?vue&type=script&lang=js"

import "./NavPrompt.vue?vue&type=style&index=0&id=1dd0f8b4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__